module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-4x3-mobile@2x.3e870d00.png";